import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import "./ChessClockSale.css";

const ENQUIRY_EMAIL = "chesshampshire@gmail.com";
const ENQUIRY_LINK = `mailto:${ENQUIRY_EMAIL}?subject=Chess%20clocks%20enquiry`;
const PHOTOS = [
  { file: "hampshire-clocks.jpg", en: "Three types of Hampshire tournament chess clocks", pl: "Trzy rodzaje zegarów z turniejów w Hampshire", es: "Tres tipos de relojes de torneos de Hampshire" },
  { file: "blue-clock.jpg", en: "Blue analogue chess clock", pl: "Niebieski analogowy zegar szachowy", es: "Reloj de ajedrez analógico azul" },
  { file: "wooden-clock.jpg", en: "Analogue chess clock", pl: "Analogowy zegar szachowy", es: "Reloj de ajedrez analógico" },
  { file: "cream-clock.jpg", en: "Cream chess clock with dark dials", pl: "Kremowy zegar szachowy z ciemnymi tarczami", es: "Reloj de ajedrez crema con esferas oscuras" },
];

const COPY = {
  label: { en: "FROM THE HAMPSHIRE CHESS COMMUNITY", pl: "OD SZACHOWEJ SPOŁECZNOŚCI HAMPSHIRE", es: "DE LA COMUNIDAD DE AJEDREZ DE HAMPSHIRE" },
  title: { en: "Chess clocks for sale", pl: "Zegary szachowe na sprzedaż", es: "Relojes de ajedrez en venta" },
  history: { en: "These clocks were previously used in chess tournaments in Hampshire.", pl: "Tymi zegarami grano na turniejach szachowych w Hampshire.", es: "Estos relojes se utilizaron en torneos de ajedrez en Hampshire." },
  description: { en: "25 used analogue clocks, available individually or as a complete lot. See the photographs for the available models.", pl: "25 używanych zegarów analogowych — pojedynczo lub w komplecie. Dostępne modele przedstawiono na zdjęciach.", es: "25 relojes analógicos usados, disponibles por separado o como lote completo. Consulta las fotografías para ver los modelos disponibles." },
  blue: { en: "Blue clocks", pl: "Niebieskie zegary", es: "Relojes azules" },
  others: { en: "Other clocks", pl: "Pozostałe zegary", es: "Otros relojes" },
  each: { en: "each", pl: "za sztukę", es: "cada uno" },
  discount: { en: "25% off the complete lot", pl: "25% rabatu na cały komplet", es: "25% de descuento en el lote completo" },
  terms: { en: "Buy all 25 and save 25% on the combined individual prices.", pl: "Kup wszystkie 25 sztuk, a otrzymasz 25% rabatu od sumy ich cen pojedynczych.", es: "Compra los 25 y ahorra un 25% sobre la suma de sus precios individuales." },
  contact: { en: "Enquire by email", pl: "Zapytaj e-mailem", es: "Consultar por correo" },
  availability: { en: "Please message for current availability and purchase arrangements.", pl: "Napisz, aby sprawdzić aktualną dostępność i ustalić szczegóły zakupu.", es: "Escríbenos para consultar la disponibilidad y acordar la compra." },
  view: { en: "Open full-size photograph", pl: "Otwórz zdjęcie w pełnym rozmiarze", es: "Abrir la fotografía a tamaño completo" },
  gallery: { en: "Choose a clock photograph", pl: "Wybierz zdjęcie zegara", es: "Elige una fotografía del reloj" },
};

export default function ChessClockSale() {
  const { pick } = useLanguage();
  const [selected, setSelected] = useState(0);
  const photo = PHOTOS[selected];
  const imagePath = (file) => `/images/chess-clocks/${file}`;

  return (
    <section className="ch-clock-sale" id="chess-clocks" aria-labelledby="ch-clock-sale-title">
      <div className="ch-clock-sale-gallery">
        <a className="ch-clock-sale-photo" href={imagePath(photo.file)} target="_blank" rel="noopener noreferrer" aria-label={`${pick(COPY.view)}: ${pick(photo)}`}>
          <img src={imagePath(photo.file)} alt={pick(photo)} width="1536" height="1152" loading="lazy" />
          <span>{pick(COPY.view)} ↗</span>
        </a>
        <div className="ch-clock-sale-thumbnails" role="group" aria-label={pick(COPY.gallery)}>
          {PHOTOS.map((item, index) => (
            <button key={item.file} type="button" onClick={() => setSelected(index)} aria-pressed={selected === index} aria-label={pick(item)}>
              <img src={imagePath(item.file)} alt="" width="1536" height="1152" loading="lazy" />
            </button>
          ))}
        </div>
      </div>
      <div className="ch-clock-sale-content">
        <p className="ch-clock-sale-eyebrow">{pick(COPY.label)}</p>
        <h2 id="ch-clock-sale-title">{pick(COPY.title)}</h2>
        <p className="ch-clock-sale-history">{pick(COPY.history)}</p>
        <p>{pick(COPY.description)}</p>
        <dl className="ch-clock-sale-prices">
          <div><dt><span className="ch-clock-sale-blue" aria-hidden="true" />{pick(COPY.blue)}</dt><dd>£30 <span>{pick(COPY.each)}</span></dd></div>
          <div><dt>{pick(COPY.others)}</dt><dd>£20 <span>{pick(COPY.each)}</span></dd></div>
        </dl>
        <div className="ch-clock-sale-discount"><strong>{pick(COPY.discount)}</strong><p>{pick(COPY.terms)}</p></div>
        <a className="ch-clock-sale-contact" href={ENQUIRY_LINK}>{pick(COPY.contact)} <span aria-hidden="true">↗</span></a>
        <p className="ch-clock-sale-availability"><span>{ENQUIRY_EMAIL}</span><br />{pick(COPY.availability)}</p>
      </div>
    </section>
  );
}
